import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Divider from '@material-ui/core/Divider';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import green from '@material-ui/core/colors/green';


const styles = theme => ({
  toolbarRoot: {
    padding: 0,
    backgroundColor: theme.palette.secondary[900]
  },
  titleHead: {
    margin: '4px 12px',
    fontSize: '18px',
    color: '#ffffff'
  },
  contentMessage: {
    padding: '36px 12px',
    fontSize: '16px'
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  bttnSuccess: {
    backgroundColor: green[400],
    '&:hover': {
      backgroundColor: green[600]
    }
  },
  fabProgress: {
    margin: theme.spacing.unit,
    position: 'absolute',
    right: 18,
    top: 0,
    zIndex: 1
  }
});


class RUCancellationDialog extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      cancellationObs: ''
    }
  }

  handleClose = () => {
    this.props.handleClose();
  };

  handleChangeCancellation = name => event => {
    this.setState({ [name]: event.target.value });
  };


  render() {
    const { classes } = this.props;
    const buttonClassname = classNames({ [classes.bttnSuccess]: this.props.success });

    return (
      <div>
        <Dialog
          fullWidth
          maxWidth='sm'
          open={this.props.openCancellationDialog}>

          <Paper>
            <Toolbar className={classes.toolbarRoot}>
              <Typography variant='title' className={classes.titleHead}>
                {this.props.confirmationQuestion}
              </Typography>
            </Toolbar>
          </Paper>

          <DialogContent className={classes.contentMessage}>
            <DialogContentText>
              {this.props.confirmationMessage}
            </DialogContentText>
            <Grid item xs={12} sm={12}>
              <TextField
                id='cancellationObs'
                label='OBSERVAÇÃO DE CANCELAMENTO'
                margin='dense'
                fullWidth
                multiline
                rows='1'
                rowsMax='3'
                inputProps={{ maxLength: 500 }}
                value={this.state.cancellationObs}
                onChange={this.handleChangeCancellation('cancellationObs')}
              />
            </Grid>
          </DialogContent>

          <Divider />
          <DialogActions disableActionSpacing>
            <Toolbar>
              <Tooltip title='Cancelar' placement='bottom' >
                <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.props.cancelFunction}>
                  <CloseIcon />
                </Button>
              </Tooltip>

              <Tooltip title='Confirmar' placement='bottom' >
                <Button disabled={this.props.loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={() => this.props.confirmationFunction(this.state.cancellationObs)}>
                  <CheckIcon />
                  {this.props.success}
                </Button>
              </Tooltip>
              {this.props.loading && <CircularProgress size={48} color='primary' className={classes.fabProgress} />}
            </Toolbar>
          </DialogActions>

        </Dialog>
      </div>
    )
  }
}

RUCancellationDialog.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(RUCancellationDialog);


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsCreation/UsedRentalsEditLots/RUCancellationDialog.js